export const DESKTOP_SCREEN_SIZE = {
    width: 1024,
  }
  